<div class="brand-card" (click)="onCardClick()">
  <img src="{{brand.imageUrl}}" alt="">
</div>
